import { memo, useEffect } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlSystemBoardListRequest } from "../../models/service-models/board/SystemBoardListRequest";
import { BoardService } from "../../services/BoardService";

export type SystemBoardSelectProps = {
    onChange?: Function;
    value?: any;
}


export const SystemBoardSelect = memo(function SystemBoardSelect(props: SystemBoardSelectProps) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!data)
            refetch();
    }, [props]);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getSystemBoards"],
        () => {
            var request: mdlSystemBoardListRequest = { pageSize: 0 };
            return BoardService.SystemBoardList(request);
        },
        {
            refetchOnWindowFocus: false,
            enabled: false
        }
    );

    return (
        <>
            <Select                
                size="large"
                loading={isLoading}
                value={props.value}
                onSelect={(value: string) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("definitions.boards.chooseSystemBoard")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data?.body?.data?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.accommodationTypeId
                }))}
            />
        </>
    )
})